import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-plus"} maskId="square-filled-radius-0-stroke-1-IconHomePlus"><path fillRule="evenodd" clipRule="evenodd" d="M21 8.21387V21H3V8.21387L12 2.91992L21 8.21387ZM11.5 12.5H9V13.5H11.5V16H12.5V13.5H15V12.5H12.5V10H11.5V12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomePlus;
